import React, {useEffect, useState} from 'react';
import MediaLibraryManager from '../Media/MediaLibraryManager';
import {isBrowserPreviewableImage, mediaKind} from '../Media/MediaCard';

const FILE_ICON_CLASSES = {
    image: 'fa-file-image',
    video: 'fa-file-video',
    audio: 'fa-file-audio',
    pdf: 'fa-file-pdf',
    file: 'fa-file',
};

function previewUrl(file) {
    if (!file?.cdnUrl) return '';
    return `${file.cdnUrl}?w=320&h=240&etag=${file.etag || file.uuid || ''}`;
}

export default function ProductMediaPicker({
    name,
    value,
    file,
    accept = '',
    title,
    chooseLabel,
    emptyLabel,
    onChange,
}) {
    const [pickerOpen, setPickerOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        if (!value) {
            setSelectedFile(null);
            return;
        }
        if (file?.id != null && String(file.id) === String(value)) {
            setSelectedFile(file);
        }
    }, [file, value]);

    const selectedKind = selectedFile ? mediaKind(selectedFile) : 'file';
    const selectedLabel = selectedFile?.title || selectedFile?.filename || 'Selected file';

    return (
        <div className="product-media-picker">
            <input type="hidden" name={name} value={value || ''} readOnly />

            {selectedFile ? (
                <div className="product-media-picker-selection">
                    <div className="product-media-picker-preview">
                        {selectedKind === 'image' && isBrowserPreviewableImage(selectedFile)
                            && previewUrl(selectedFile) ? (
                                <img src={previewUrl(selectedFile)} alt={selectedLabel} />
                            ) : (
                                <i
                                    className={`far ${FILE_ICON_CLASSES[selectedKind]}`}
                                    aria-hidden="true"
                                ></i>
                            )}
                    </div>
                    <div>
                        <strong>{selectedLabel}</strong>
                        <span>
                            {selectedFile.mimetype || selectedFile.extension || 'File'}
                        </span>
                    </div>
                </div>
            ) : value ? (
                <p className="help">
                    A file is selected. Open the media library to preview or replace it.
                </p>
            ) : (
                <p className="help">{emptyLabel}</p>
            )}

            <div className="product-media-picker-actions">
                <button type="button" className="button small" onClick={() => setPickerOpen(true)}>
                    {chooseLabel}
                </button>
                {value && (
                    <button
                        type="button"
                        className="button small secondary"
                        onClick={() => onChange(null)}
                    >
                        Remove
                    </button>
                )}
            </div>

            {pickerOpen && (
                <MediaLibraryManager
                    variant="modal"
                    isOpen
                    selectable
                    initialValue={value || ''}
                    accept={accept}
                    title={title}
                    onSelect={nextFile => {
                        setSelectedFile(nextFile);
                        onChange(nextFile.id);
                        setPickerOpen(false);
                    }}
                    onCancel={() => setPickerOpen(false)}
                />
            )}
        </div>
    );
}
